import React from "react";

import DocumentsUploadPage from "EmployerApplication/pages/DocumentsUploadPage";
import { renewalOpenEnrollmentURL, renewalDoneURL } from "EmployerApplication/urls";

const DocumentUploadPage = () => <DocumentsUploadPage backURL={renewalOpenEnrollmentURL} nextURL={renewalDoneURL} />;

export default DocumentUploadPage;
